import { useEffect, useRef } from "react";

// Global layer stack so the hardware/browser Back button closes the topmost
// open layer (product modal, cart drawer, filtered view) instead of exiting the app.
const stack = [];
let suppress = 0;
let listening = false;

function ensureListener() {
  if (listening) return;
  listening = true;
  window.addEventListener("popstate", () => {
    if (suppress > 0) {
      suppress -= 1;
      return;
    }
    const top = stack.pop();
    if (top) {
      top.byPop = true;
      top.close();
    }
  });
}

export function useBackClose(isOpen, close) {
  const closeRef = useRef(close);
  closeRef.current = close;
  useEffect(() => {
    if (!isOpen) return undefined;
    ensureListener();
    const entry = { close: () => closeRef.current(), byPop: false };
    stack.push(entry);
    window.history.pushState({ layer: stack.length }, "");
    return () => {
      const idx = stack.indexOf(entry);
      if (idx !== -1) stack.splice(idx, 1);
      if (!entry.byPop) {
        suppress += 1;
        window.history.back();
      }
    };
  }, [isOpen]);
}
